<template>
  <v-timeline align-top dense>
    <template v-for="lineaSeguimiento in seguimiento">
      <v-timeline-item 
        :key="lineaSeguimiento.IDSEGUIMIENTO"
        color="blue lighten-3" 
        small>
        <v-layout pt-2>
          <v-flex xs2>
            <strong>{{ lineaSeguimiento.FECHA | moment("DD/MM/YYYY hh:mm")}}</strong>
          </v-flex>
          <v-flex xs10>
            <strong>{{ lineaSeguimiento.DESCRIPCION }}</strong>
            <div class="caption" style="white-space: pre">{{ lineaSeguimiento.AMPLIACION }}</div>
          </v-flex>
        </v-layout>
      </v-timeline-item>
    </template>
  </v-timeline>
</template>

<style>
</style>

<script>
  import { mapState } from 'vuex'
  import { SEGUIMIENTO_REQUEST } from '../store/actions/incidencias';

  export default {
    name: 'VerSeguimientoLiquidacion',
    props: {
      'idIncidencia': { type: Number, required: true }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.cargarSeguimiento()
    },
    methods: {
      cargarSeguimiento() {
        this.$store.dispatch(SEGUIMIENTO_REQUEST, {
          idIncidencia: this.idIncidencia
        })
      }
    },
    computed: {
      ...mapState({
        seguimiento: state => state.incidencias.seguimiento
      })
    }
  }
</script>